import { Overlay } from "react-vant";
import { useState, useEffect, useRef } from "react";
import ErrorMsg from "../ui/ErrorMsg";
import { checkEmailRegister } from "@/pages/api/auth";
import AlreadyHaveAccount from "@/components/login/ui/AlreadyHaveAccount";
import Input from "@/components/login/ui/Input";
import { useTranslation } from "next-i18next";
import { sendSlsEvent } from "@/hooks/useAnalytics";
import { useElapsedTime } from "@/utils/useElapsedTime";
import { useRouter } from "next/router";
interface EmailRegistryFormProps {
  goVerifyCode: () => void;
  goLogin: () => void;
  userInputEmail: string;
  onVerifyCodeType: (type: string) => void;
  goEmailRegistred: () => void;
  onEmailChange: (email: string) => void;
  onFocusChange?: (focus: boolean) => void;
  autoFocus?: boolean;
  handleEmailGoogleRegistredAndNoPasswordOrigin: (
    origin: "login" | "registry"
  ) => void;
}
const EmailRegistryForm = ({
  goVerifyCode,
  goLogin,
  userInputEmail,
  onVerifyCodeType,
  goEmailRegistred,
  onEmailChange,
  onFocusChange,
  autoFocus = false,
  handleEmailGoogleRegistredAndNoPasswordOrigin,
}: EmailRegistryFormProps) => {
  const getElapsed = useElapsedTime();
  const pageId = "mailsignup_web";
  const { t } = useTranslation();
  const router = useRouter();
  const [email, setEmail] = useState(userInputEmail);
  const [errorMsg, setErrorMsg] = useState({
    message: "",
    show: false,
  });
  const [showRegistedDialog, setShowRegistedDialog] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const isFirstRenderRef = useRef(true);

  const checkEmail = async (email: string): Promise<{ message: string }> => {
    console.log("checkEmail", email);
    const isValidEmailStr =
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
    return new Promise((resolve) => {
      if (!email) {
        resolve({ message: t("login.emailnotEmpty") });
        return;
      }
      if (!isValidEmailStr) {
        resolve({ message: t("login.emailnotvalid") });
        return;
      }
      resolve({ message: "" });
    });
  };
  const handleContinue = async () => {
    if (disabled) {
      return;
    }
    const { message } = await checkEmail(email);
    if (message) {
      setErrorMsg({
        message: message,
        show: true,
      });
      return;
    }
    // 检查邮箱是否注册
    const res = await checkEmailRegister({
      email: email,
      type: 0,
    });
    console.log("res-----", res);
    const { isRegister, hasPassword, isThirdLogin } = res || {};
    // 已经注册
    if (isRegister) {
      console.log("已经注册", isRegister);
      // 有密码
      if (hasPassword) {
        console.log("已经注册， 并且有密码", hasPassword);
        // 展示弹窗
        setShowRegistedDialog(true);
        return;
      }
      // 没有密码
      if (!hasPassword) {
        console.log("已经注册， 但是没有密码", hasPassword);
        // 跳转到设置密码
        handleEmailGoogleRegistredAndNoPasswordOrigin("registry");
        goEmailRegistred();
      }
      return;
    }
    console.log("没有注册", isRegister);
    onVerifyCodeType("0"); // 注册
    goVerifyCode();
  };
  const handleRegistedDialogClose = () => {
    setShowRegistedDialog(false);
  };
  const handleGoLogin = () => {
    setShowRegistedDialog(false);
    goLogin();
  };
  const handleEmailChange = (v: string) => {
    checkEmail(v).then((res) => {
      setDisabled(res.message !== "");
    });

    setEmail(v);
    onEmailChange(v);
    setErrorMsg({
      message: "",
      show: false,
    });
  };
  const handleLeft = () => {
    console.log("handleLeft---email-registry-form----");
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_PageLeave",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_DistinctID: "",
      UM_Key_UserID: "",
      UM_Key_Duration: getElapsed(),
    });
  };
  useEffect(() => {
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_PageView",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_DistinctID: "",
      UM_Key_UserID: "",
    });
  }, []);
  useEffect(() => {
    return () => {
      console.log("left");
      handleLeft();
    };
  }, []);

  useEffect(() => {
    console.log("isFirstRenderRef", isFirstRenderRef.current, email);
    if (isFirstRenderRef.current) {
      if (email) {
        setDisabled(false);
      }
      isFirstRenderRef.current = false;
      return;
    }
    checkEmail(email).then((res) => {
      setDisabled(res.message !== "");
      setErrorMsg({
        message: res.message,
        show: !!res.message,
      });
    });
  }, [email]);
  return (
    <div className="flex flex-col w-[calc(100vw-40px)]">
      <div className="w-full  mb-[166px]">
        <Input
          value={email}
          onChange={handleEmailChange}
          onFocusChange={onFocusChange}
          autoFocus={autoFocus}
          placeholder={t("login.emailDesc")}
          classNames="bg-[#f2f2f2] rounded-[100px] mt-[30px] h-[56px] ps-[20px] font-[700] font-['Mulish'] mb-[4px]"
        />
        <ErrorMsg message={errorMsg.message} show={errorMsg.show} />
      </div>

      <div
        onClick={handleContinue}
        className={`${
          disabled ? "bg-[#1677FF] opacity-[0.3]" : "bg-[#1677FF]"
        } rounded-[4px] h-[56px] text-[#fff] font-[700] font-['Mulish'] bg-[#1677FF] flex items-center justify-center w-full cursor-pointer`}
      >
        {t("login.continue")}
      </div>
      <AlreadyHaveAccount
        pageId={pageId}
        goLogin={() => {
          handleEmailChange("");
          goLogin();
        }}
        classNames="mt-[12px]"
      />
      <Overlay
        visible={showRegistedDialog}
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="flex flex-col items-center w-[calc(100vw)]  bg-[transparent]">
          <div className="w-[calc(100vw-40px)] relative bg-[#fff] rounded-[16px] p-[20px]">
            <div className="text-[18px] font-['Mulish'] font-[700] text-[#333] mb-[20px]">
              {t("login.emailAlreadyRegistered")}
            </div>
            <div className="text-[14px] font-[700] font-['Mulish'] text-[#999]">
              <span className="text-[#333]">{email}</span>
              <span className="text-[14px] font-[400] font-['Mulish'] text-[#999]  mb-[20px]">
                {t("login.logInDirectly")}
              </span>
            </div>
            <div className="text-[14px] font-[400] font-['Mulish'] text-[#999]  mb-[20px]"></div>
            <div
              onClick={handleGoLogin}
              className=" h-[37px] bg-[#1677ff] font-['Mulish'] text-[#fff] font-[700] mb-[10px] cursor-pointer  rounded-[8px] flex justify-center items-center"
            >
              {t("login.gotoLogin")}
            </div>
            <div
              onClick={handleRegistedDialogClose}
              className=" h-[37px] bg-[#f5f5f5] text-[#333] font-['Mulish'] font-[700] cursor-pointer  rounded-[8px] flex justify-center items-center"
            >
              {t("login.cancel")}
            </div>
          </div>
        </div>
      </Overlay>
    </div>
  );
};

export default EmailRegistryForm;
